<template>
  <div>
    <el-row style="display: flex">
      <block-select type="alogorithm"/>
      <div style="margin-top: 9px">
        <span style="font-size: 14px">年份：</span>
        <el-date-picker
            v-model="year_mon"
            type="year"
            value-format="YYYY"
            placeholder="请选择"
            size="small"
        ></el-date-picker>
      </div>
      <div style="margin-top: 9px;margin-left: 12px;margin-right: 12px">
        <span style="font-size: 14px">分类：</span>
        <el-select v-model="indexName" size="small">
          <el-option
              v-for="item in indexNameList"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
        </el-select>
      </div>
<!--      <el-col :span="5" style="margin-top: 5px">-->
      <el-button size="mini" type="primary" style="margin-top: 11px" @click="getTotalDate">考核总分</el-button>
        <el-button size="mini" type="primary" style="margin-top: 11px" @click="getData">查询</el-button>
        <el-button size="mini" type="primary" style="margin-top: 11px;margin-left: 5px" @click.stop="exportTable">导出</el-button>

<!--      </el-col>-->
<!--      <el-col :span="6">-->

<!--      </el-col>-->
<!--      <el-col :span="6">-->

<!--      </el-col>-->
<!--      <el-col :span="2">-->
<!--        <el-button size="mini" type="primary" style="margin-top: 5px" @click="getTotalDate">考核总分</el-button>-->
<!--      </el-col>-->
    </el-row>
    <el-table :data="tableData" v-loading="loading" v-if="'children' in tableHeader[0]" border stripe
              @cell-contextmenu="openMenu"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              id="exportTable"
              height="calc(100vh - 350px)"
              style="margin-top: 0px">
      <el-table-column
          v-for="item in tableHeader"
          :prop="item.id"
          :label="item.name"
          :key="item.id">
        <el-table-column
            v-for="it in item.children"
            :prop="it.id"
            :label="it.name"
            :key="it.id"></el-table-column>
      </el-table-column>
    </el-table>
    <el-table :data="tableData" v-loading="loading" v-else border stripe
              @cell-contextmenu="openMenu"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              id="exportTable"
              height="calc(100vh - 350px)"
              style="margin-top: 0px">
      <el-table-column
          v-for="item in tableHeader"
          :prop="item.id"
          :label="item.name"
          :key="item.id">
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="isPagination"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.dataTotal"
        :current-page="pagination.currentPage"
        @size-change="sizeChange"
        @current-change="currentChange"
        style="text-align: right;margin-top: 40px;margin-bottom: 50px">
    </el-pagination>

    <!--右键数据反馈 弹窗 -->
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="openFeedback">指标异议记录</li>
    </ul>

    <!--考核指标评分——弹出框-->
    <div v-dialogDrag>
      <el-dialog
          v-model="isFeedback"
          title="指标异议记录"
          width="30%">
          <el-form :model="feedbackFrom" label-width="110px">
            <el-form-item label="关键信息：">
              <label>{{feedbackFrom.information}}</label>
            </el-form-item>
            <el-form-item label="反馈字段：">
              <label>{{feedbackFrom.feedbackField.name}}</label>
            </el-form-item>
            <el-form-item label="异议值：">
              <el-row>
                <el-col :span="8">
                  <label>{{feedbackFrom.fieldData}}</label>
                </el-col>
                <el-col :span="4" :offset="4">
                  <label>修改值:</label>
                </el-col>
                <el-col :span="8">
                  <el-input v-model="feedbackFrom.feedbackFielddata" style=""></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="修改原因：">
              <el-input type="textarea" :rows="5"  v-model="feedbackFrom.reason" style=""></el-input>
            </el-form-item>
          </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="isFeedback = false">取消</el-button>
                <el-button type="primary" @click="submitFeedback">提交</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessage} from "element-plus";
import {_exportTable} from "../../../public/static/js/util";
import BlockSelect from "@/components/blockSelect";

export default {
  name: "AlgorithmResultMangerView",
  components: {BlockSelect},
  data(){
    return{
      indexName:"月度指标",//指标分类
      indexNameList:[
        {
          value:"月度指标",
          label: "月度指标符合率",
          key:"index_mon"
        },
        {
          value:"年度指标",
          label: "年度指标符合率",
          key:"index_yaer"
        },
        // {
        //   value: "关键项目符合率",
        //   label: "关键项目符合率",
        //   key:"dynamic_project"
        // },
        // {
        //   value: "动态监测资料质量",
        //   label: "动态监测资料质量",
        //   key:"dynamic_data"
        // },
        // {
        //   value: "安全生产",
        //   label: "安全生产",
        //   key:"dynamic_security"
        // },
        {
          value: "下年度方案编制",
          label: "综合治理方案",
          key:"programme_nextYear"
        }
      ],//指标分类列表
      year_mon:null,//年度
      pagination:{
        dataTotal:1,//总条目数
        currentPage:1,//当前页数
        pageSize: 20,//每页所展示的数量
      },//分页相关数据
      isPagination:true,//分页显示标识
      tableHeaderTempDouble:[
        {
          id:"kf",
          name:"",
          children:[
            {
              id:"KFB",
              name:"开发部",
            }
          ]
        },
        {
          id:"date",
          name:"",
          children:[
            {
              id:"YEAR_MON",
              name:"年度",
            }
          ]
        },
        {
          id:"zfz",
          name: "",
          children: [
            {
              id:"TOTAL_POINTS",
              name: "总得分"
            }
          ]
        }
      ],//表头数据模板——双层表头
      tableHeaderTemp: [
        {
          id: "KFB",
          name: "开发部",
        },
        {
          id: "YEAR_MON",
          name: "年度",
        },
        {
          id: "TOTAL_POINTS",
          name: "总得分"
        }
      ],//表头数据模板
      tableHeader:[
        {
          children:"",
        }
      ],//表头数据展示
      tableData:[],//报表数据
      loading:false,//数据加载标识
      visible:false,//右键数据反馈 弹窗 展示标识
      left:0,//出现位置——右键数据反馈 弹窗
      top:0,//出现位置——右键数据反馈 弹窗
      isFeedback:false,//指标异议记录 弹窗 展示标识
      feedbackFrom:{
        information:"",//相关信息
        feedbackField: null,//反馈字段
        fieldData:"",//异议值
        feedbackFielddata:"",//修改值
        reason:"",//原因
      },
      feedbackSubmitData:{},//指标异议提交数据

      TableHeaderTempTotal:[
        {
          id:"kf",
          name:"",
          children:[
            {
              id:"KFB",
              name:"开发部",
            }
          ]
        },
        {
          id:"date",
          name:"",
          children:[
            {
              id:"YEAR_MON",
              name:"年度",
            }
          ]
        },
        {
          id:"index",
          name:"指标符合率(40分)",
          children:[
            {
              id:"index_mon",
              name:"月度指标得分",
            }, {
              id:"index_yaer",
              name:"年度指标得分",
            }
          ]
        },
        // {
        //   id:"dynamic",
        //   name:"动态监测指标(10分)",
        //   children:[
        //     {
        //       id:"dynamic_project",
        //       name:"关键项目符合率得分",
        //     }, {
        //       id:"dynamic_data",
        //       name:"动态监测资料质量得分",
        //     }, {
        //       id:"dynamic_security",
        //       name:"安全生产得分",
        //     }
        //   ]
        // },
        {
          id:"programme",
          name:"综合治理方案(50分)",
          children:[
            {
              id:"programme_nextYear",
              name:"下年度方案编制得分",
            }
          ]
        },
        {
          id:"zfz",
          name: "",
          children: [
            {
              id:"TOTAL_POINTS",
              name: "总得分"
            }
          ]
        }
      ],//表头数据模板——双层表头（总得分）
      isTotal:false,//展示总得分标识
    }
  },
  mounted() {
    let date=new Date();
    this.year_mon=date.getFullYear().toString();
    this.getData();
  },
  methods:{
    //获取报表数据
    getData(){
      if (this.year_mon==null || this.year_mon==""){
        ElMessage("请选择年份");
        return
      }
      this.isPagination=true;
      this.loading=true;
      this.isTotal=false;
      let checkedBlock=JSON.parse(localStorage.getItem("checkedBlock"));//勾选区块信息
      let blkTypeID= localStorage.getItem("blockType");//获取勾选区块类型
      if (checkedBlock == null || checkedBlock==undefined)
        checkedBlock = "";
      if (blkTypeID == null || blkTypeID==undefined)
        blkTypeID = "02";
      let checkedBlk=Object.keys(checkedBlock).toString();//获取勾选区块id字符串
      let token = localStorage.getItem("lyqtJwt");
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      // let url=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/inquire?AppID=54e8099c-4202-485f-9503-13bd0dce5f53&AppSercect=4mjp5emfes3g6xxuxd4nulux" +
      let url=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/inquire" +
          "?assessSubclass="+this.indexName+"&yearMon="+this.year_mon;
      let params={
        "user_id":"0000001",
        "user_empid":"EPLYTL110148104",
        "app_id":"BF839CB76B40431CAE8F4E9E7B252116",
        "checkedBlk":"",
        "queryFilter":[],
        "conditionStr":"",
        "total":true,
        "pageIndex":this.pagination.currentPage,
        "pageSize":this.pagination.pageSize,
        "params":{
          "blkTypeID":blkTypeID,
          "checkedBlk":checkedBlk
        }
      };
      console.log("params",params);
      axios.post(url,params,{ headers:{"authorization": "Bearer " + token},}).then(res => {
        console.log(res);
        if (res.data.success==true){
          this.tableData=res.data.content;
          this.pagination.dataTotal=res.data.totalElements;
          //拼接表头,"安全生产"，”下年度方案编制“是单表头
          this.tableHeader=JSON.parse(JSON.stringify(this.tableHeaderTempDouble));
          if (this.indexName=="安全生产" || this.indexName=="下年度方案编制"){
            this.tableHeader=JSON.parse(JSON.stringify(this.tableHeaderTemp));
          }
          for (let i=0;i<res.data.tableHeader.length;i++){
            this.tableHeader.splice(2+i,0,res.data.tableHeader[i]);
          }
        }else {
          this.tableData=[];
          this.pagination.dataTotal=0;
          ElMessage(res.data.msg);
        }
        this.loading=false;
      }).catch(err => {
        console.log(err);
      });
    },
    //考核总分按钮
    getTotalDate(){
      if (this.year_mon==null || this.year_mon==""){
        ElMessage("请选择年份");
        return
      }
      this.isPagination=false;
      this.loading=true;
      this.isTotal=true;
      let checkedBlock=JSON.parse(localStorage.getItem("checkedBlock"));//勾选区块信息
      let blkTypeID= localStorage.getItem("blockType");//获取勾选区块类型
      if (checkedBlock == null || checkedBlock==undefined)
        checkedBlock = "";
      if (blkTypeID == null || blkTypeID==undefined)
        blkTypeID = "02";
      let checkedBlk=Object.keys(checkedBlock).toString();//获取勾选区块id字符串
      console.log("yun",checkedBlk)
      let url=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/getTotalDate";
      let params={
        "user_id":"0000001",
        "user_empid":"EPLYTL110148104",
        "app_id":"BF839CB76B40431CAE8F4E9E7B252116",
        "checkedBlk":"",
        "queryFilter":[],
        "conditionStr":"",
        "total":true,
        "pageIndex":this.pagination.currentPage,
        "pageSize":9999,
        "params":{
          "blkTypeID":blkTypeID,
          "checkedBlk":checkedBlock
        }
      };
      console.log("params", params);
      axios.post(url, {
            year_mon: this.year_mon,
            indexNameList: this.indexNameList,
            params: params
          }).then(res => {
        console.log(res);
        this.tableHeader=this.TableHeaderTempTotal;
        this.pagination.dataTotal=res.data.totalElements;
        this.tableData=res.data.content;
        this.loading=false;
      }).catch(err=>{
        console.log(err);
      })
    },
    //分页组件————每页展示条数切换
    sizeChange(pageSize){
      console.log(pageSize)
      this.pagination.pageSize = pageSize;
      this.getData();
    },
    //分页组件————点击第几页
    currentChange(currentPage){
      console.log(currentPage)
      this.currentPage=currentPage;
      this.getData();
    },
    //打开 右键数据反馈 弹窗
    openMenu(row, column, cell, event) {
      // console.log(row)
      // console.log(column)
      // console.log(cell)
      // console.log(event)
      window.event.returnValue = false;//不触发浏览器右键事件
      console.log("tackle",column);
      let cantackleCol = {"index_yaer":1,
        "index_mon":1,
        "dynamic_project":1,
        "dynamic_data":1,
        "dynamic_security":1,
        "programme_nextYear":1};
      if(cantackleCol[column.property] != 1){
        ElMessage("该值不支持异议！")
        return;
      }
      // if (column.property=="KFB" || column.property=="YEAR_MON"){
      //   ElMessage("该值不支持异议！")
      //   return;
      // }
      //获取弹窗位置
      this.top = event.clientY;
      this.left = event.clientX;
      //获取异议相关信息
      this.feedbackFrom.information=row["KFB"]+" "+row["YEAR_MON"];
      this.feedbackFrom.fieldData=row[column.property];
      let field={};
      field.id=column.property;
      field.name=column.label;
      //获取一级表头名称并拼接
      for (let i=2;i<this.tableHeader.length;i++){
        if (field.id.indexOf(this.tableHeader[i].id)!=-1){
          field.name=this.tableHeader[i].name+"——"+field.name;
          break;
        }
      }
      this.feedbackFrom.feedbackField=field;

      this.feedbackSubmitData.KFB=row["KFB"];//开发部
      this.feedbackSubmitData.YEAR_MON=row["YEAR_MON"];//年度
      this.feedbackSubmitData.FIELD=this.feedbackFrom.feedbackField.name;//反馈字段
      this.feedbackSubmitData.OBJECTION_VALUE=this.feedbackFrom.fieldData;//异议值
      this.feedbackSubmitData.INDEX_TYPE = this.isTotal ? "考核评分" : this.indexName;//指标类型

      this.visible=true;
    },
    //关闭 右键数据反馈弹窗
    closeMenu() {
      this.visible = false;
    },
    //点击 指标异议记录 按钮
    openFeedback(){
      this.isFeedback=true;
    },
    //提交按钮 指标异议记录
    submitFeedback(){
      if (this.feedbackFrom.feedbackFielddata==""){
        ElMessage("请输入修改值");
        return
      }
      this.feedbackSubmitData.MODIFY_VALUE=this.feedbackFrom.feedbackFielddata;//修改值
      this.feedbackSubmitData.REASON=this.feedbackFrom.reason;//修改原因
      this.feedbackSubmitData.SUBMITTER=JSON.parse(localStorage.getItem("lyqtUserInfo")).displayName;//提交人
      this.feedbackSubmitData.SUBMISSION_TIME=new Date().toLocaleString();//提交时间
      console.log(this.feedbackSubmitData);
      let url=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/addFeedback";
      axios.post(url,{feedbackSubmitData:this.feedbackSubmitData}).then(res=>{
        console.log(res);
        if (res.data.success==true){
          ElMessage.success("已提交");
          this.isFeedback=false;
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    //报表文件导出函数
    exportTable() {
      if (this.tableData.length == 0) {
        ElMessage.info("无报表数据");
        return
      }
      let excelName = ""
      this.indexNameList.forEach(item => {
        if (item.value == this.indexName) {
          excelName = item.label;
        }
      });
      excelName = this.isTotal ? "考核总分" : excelName;
      excelName += this.year_mon;
      _exportTable(excelName);
    },
  },
  watch:{
    //监听 右键数据反馈 弹窗展示标识 状态
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);//添加点击事件
      } else {
        document.body.removeEventListener('click', this.closeMenu);//移除点击事件
      }
    }
  }
}
</script>

<style scoped>
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}
.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background-color: rgb(3, 125, 243);;
  color: white;
}

/*/deep/.el-table th {*/
/*  overflow: hidden;*/
/*  -webkit-user-select: none;*/
/*  -moz-user-select: none;*/
/*  user-select: none;*/
/*  background: #e5f9f9;*/
/*  color: #545c64;*/
/*  border: 1px solid lightgray;*/
/*  font-size: 14px;*/
/*  text-align: center;*/
/*}*/
/*/deep/.el-table thead.is-group th{*/
/*  background: #e5f9f9;*/
/*}*/
/*/deep/.el-table--border td{*/
/*  border: 1px solid #e5e5e5;*/
/*}*/
/*/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {*/
/*  background: #e6f0f9;*/
/*}*/
/*/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {*/
/*  !*background-color: #F5F7FA;*!*/
/*  background-color: #fffadf;*/
/*  border: 1px solid #fffacf;*/
/*}*/
/*/deep/.el-divider__text {*/
/*  position: absolute;*/
/*  background-color: #FFF;*/
/*  padding: 0 20px;*/
/*  color: #303133;*/
/*  font-size: 20px;*/
/*  font-weight: bold;*/
/*}*/
/*/deep/.el-table__header tr,*/
/*/deep/.el-table__header th {*/
/*  padding: 0;*/
/*  height: 35px;*/
/*}*/
/*/deep/.el-table__body tr,*/
/*/deep/.el-table__body td {*/
/*  padding: 0;*/
/*  height: 25px;*/
/*}*/
</style>